/* tslint:disable */
/* eslint-disable */
export enum NotificationSourceType {
    Events = 1,
    EventSettings = 2,
    Statistics = 3,
    Users = 4,
    Payments = 5,
    Attendance = 6,
    All = 7,
}